import { Component, OnInit, ViewChild } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { MenuComponent } from './menu/menu.component';
import { RoutingConfig } from 'src/app/utils/routing-config';
import { lastValueFrom, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { getAppConfig } from 'src/app/utils/states-management/selector/countries.selector';
import { getOwnerState, selectOwner } from 'src/app/utils/states-management/reducers/owner.reducer';
import Owner from 'src/app/models/owner.model';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  @ViewChild('nav') nav: IonNav;
  rootParams;
  showHeader = false;
  titleHeader = '';
  activeTab;
  profileConfig
  selectedTab
  constructor(
    private routingConfig: RoutingConfig,
    public store: Store

  ) { }
  async ngAfterViewInit(): Promise<void> {

    let owner = await lastValueFrom(this.store.select(getOwnerState).pipe(take(1)))
    // this.store.select(getOwnerState).subscribe((owner) => {
    let app_config = JSON.parse(owner?.countrie?.config)

    this.profileConfig = app_config?.profileConfig;
    this.rootParams = {
      nav: this.nav,
      rootStack: MenuComponent,
      isDashboardView: true,
    };
    this.nav.setRoot(MenuComponent, {
      nav: this.nav,
      selectedTab: 0,
      tabs: Object.entries(this.profileConfig)
    });
    // });

    this.nav.ionNavDidChange.subscribe(async (val) => {
      this.activeTab = await this.nav.getActive();
      this.titleHeader = this.activeTab?.params?.title;
      this.activeTab?.params?.sub_tab
        ? (this.showHeader = this.activeTab.params?.sub_tab)
        : (this.showHeader = false);
    });
  }
  async goBack() {
    this.nav.setRoot(MenuComponent, {
      nav: this.nav,
      selectedTab: this.activeTab?.params?.tab,
      tabs: Object.entries(this.profileConfig)
    });
  }
  async ngOnInit() {

    // this.nav.ionNavDidChange.subscribe((val)=>{
    // })
    // this.nav.ionNavWillChange.subscribe((val)=>console.log(val))
  }
}
